$(document).ready(function() {

    setTimeout(function() {
        $('.addOnWrapper').css('opacity', 1);
    }, 3000);

    const checkbox = document.getElementById('addonProductCheckbox');
    const button = document.querySelector('.combo-btn');


    // Toggle button text when addon selected/unselected
    if (checkbox && button) {
        checkbox.addEventListener('change', () => {
            // button.textContent = checkbox.checked ? 'Added' : 'Add';

            if (checkbox.checked) {
                const customButton = document.querySelector('.customButton');
                const realAddToCartButton = document.querySelector('.addOnBuyButtonWrapper button[type="submit"].button.w-full');
                document.querySelector('.combo-btn .plusIcon').style.display = "none";
                document.querySelector('.combo-btn .addonAddedIcon').style.display = "block";
                // setTimeout
                console.log("777");
                // customButton.style.display = 'block';
                // realAddToCartButton.style.display = 'none';



            } else {
                console.log("888");
                let customButton = document.querySelector('.customButton');
                let realAddToCartButton = document.querySelector('.addOnBuyButtonWrapper button[type="submit"].button.w-full');
                document.querySelector('.combo-btn .plusIcon').style.display = "block";
                document.querySelector('.combo-btn .addonAddedIcon').style.display = "none";
                // customButton.style.display = 'none';
                // realAddToCartButton.style.display = 'block';
            }
        });

    }
    $(document).on('click', '.customButton', function(e) {
        const addonVariantId = $('#addonProductCheckbox:checked').data('addon-variant-id');
        // console.log("<><><>", addonVariantId)
        // If addon selected, add it separately via AJAX
        if (addonVariantId) {
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: JSON.stringify({
                    items: [{
                        id: addonVariantId,
                        quantity: 1
                    }]
                }),
                dataType: 'json',
                contentType: 'application/json',
                beforeSend: function() {
                    $(".combo-btn .plusIcon").hide();
                    $(".combo-btn .addonAddedIcon").hide();
                    $(".combo-btn .loaderIcon").show();
                },
                success: function(response) {
                    // console.log('Addon added:', response);
                    $(".combo-btn .loaderIcon").hide();
                    setTimeout(function() {
                        // $(".ctForm form").submit();
                        let gpoButton = document.querySelector(".gpo-clone-atc-button");
                        if(gpoButton){
                            $(".orgButtonWrap .gpo-clone-atc-button").click();
                        }
                        else{
                            $(".orgButtonWrap button").click();
                        }
                        $(".combo-btn .addonAddedIcon").show();
                    }, 1000);
                    // Optional: show confirmation message
                    // alert('Addon product added!');
                },
                error: function(error) {
                    console.error('Addon add failed:', error);
                }
            });
        }
        else{
            // console.log("else")
            setTimeout(function() {
                let gpoButton = document.querySelector(".gpo-clone-atc-button");
                if(gpoButton){
                    $(".orgButtonWrap .gpo-clone-atc-button").click();
                }
                else{
                    $(".orgButtonWrap button").click();
                }
                // $(".ctForm form").submit();
                // $("#product-form-main-7093121220761-template--25443167207802__main").submit();
            }, 1000);
        }
    });
    // When "Add to Cart" button clicked

});